var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-text-field", {
        class: _vm.dense ? "grv-input-dense" : "grv-input",
        attrs: {
          rules: _vm.rules,
          value: _vm.value,
          name: _vm.param.name,
          clearable: "",
          readonly: _vm.readonly
        },
        on: {
          "update:error": function($event) {
            _vm.errored = $event
          },
          input: function($event) {
            return _vm.$emit("update:value", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [_c("Label", { attrs: { param: _vm.param } })]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("Hint", { attrs: { param: _vm.param, errored: _vm.errored } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c28e10c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c28e10c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/fields/char.vue
// module id = null
// module chunks = 